import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
// Self-hosted variable fonts — reduces critical font requests
import "@fontsource-variable/playfair-display/index.css";
import "@fontsource-variable/raleway/index.css";

createRoot(document.getElementById("root")!).render(<App />);
